import { Injectable, signal } from '@angular/core';
import { StatusSetDialogComponent } from '@fc-shared/ui/status-set-dialog/status-set-dialog.component';
import { DialogsService, StatusSet } from '@fc-core';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { EntityType, StatusSetApiService } from './status-set-api.service';

@Injectable({
  providedIn: 'root',
})
export class StatusSetService {
  constructor(
    private dialogs: DialogsService,
    private store: Store,
    private apiService: StatusSetApiService,
  ) {}

  openStatusSetDialog(
    entityType: EntityType,
    entityId: string | number,
    currentStatus: StatusSet | null | undefined,
    reloadAction: unknown,
  ): void {
    const loading = signal(false);
    const error = signal<string | null>(null);
    const currentStatusId = currentStatus?.id;
    const ref = this.dialogs.openFullScreenDialog(StatusSetDialogComponent, {
      data: {
        id: entityId,
        entityType,
        status: currentStatus?.status,
        icon: currentStatus?.icon,
        loading,
        error,
        updateFunction: (id: string | number, status: string, icon: string) => {
          loading.set(true);
          this.apiService
            .setStatus(entityType, id, status, icon)
            .then(() => {
              this.store.dispatch(reloadAction as never);
              loading.set(false);
              ref.close();
            })
            .catch((err: HttpErrorResponse) => {
              error.set(err.error?.status?.[0] ?? 'Failed to set status');
              loading.set(false);
            });
        },
        clearFunction:
          currentStatusId !== undefined
            ? () => {
                loading.set(true);
                this.apiService
                  .removeStatus(entityType, currentStatusId)
                  .then(() => {
                    this.store.dispatch(reloadAction as never);
                    loading.set(false);
                    ref.close();
                  })
                  .catch((err: HttpErrorResponse) => {
                    error.set(
                      err.error?.status?.[0] ?? 'Failed to clear status',
                    );
                    loading.set(false);
                  });
              }
            : null,
      },
    });
  }
}
